import type { Translations } from '../../types'

const themesMessages: Translations = {
  "themes.section.eyebrow": "Design system",
  "themes.section.title": "Theme manager",
  "themes.section.permissionSubtitle": "Questa sezione richiede la capability view_themes.",
  "themes.section.noPermission": "Non hai i permessi per visualizzare i temi.",
  "themes.section.noPermissionHint": "Chiedi al super-admin di assegnare view_themes (e opzionalmente customize_themes/activate_themes).",
  "themes.section.subtitle": "Gestione palette, tipografia e attivazione runtime su shop/admin.",
  "themes.section.stats.total": "Temi",
  "themes.section.stats.active": "Tema attivo",
  "themes.section.stats.preview": "Preview",
  "themes.section.stats.previewOn": "On",
  "themes.section.stats.previewOff": "Off",
  "themes.section.actions.preview": "Preview",
  "themes.section.actions.new": "Nuovo tema",
  "themes.section.actions.reload": "Ricarica",
  "themes.section.actions.saving": "Salvataggio...",
  "themes.section.actions.save": "Salva tema",
  "themes.section.actions.saveAndActivate": "Salva e attiva",
  "themes.section.actions.activating": "Attivazione...",
  "themes.section.actions.activateSelected": "Attiva selezionato",
  "themes.messages.loadError": "Errore caricamento temi",
  "themes.messages.loadErrorFallback": "Impossibile caricare i temi",
  "themes.messages.authRequired": "Devi essere autenticato per salvare i temi",
  "themes.messages.capabilityCustomizeMissing": "Capability mancante: customize_themes",
  "themes.messages.nameRequired": "Il nome tema e obbligatorio",
  "themes.messages.saveError": "Errore salvataggio tema",
  "themes.messages.saveErrorFallback": "Salvataggio tema fallito",
  "themes.messages.saved": "Tema salvato",
  "themes.messages.savedAndActivated": "Tema salvato e attivato",
  "themes.messages.selectThemeToActivate": "Seleziona un tema prima di attivarlo",
  "themes.messages.capabilityActivateMissing": "Capability mancante: activate_themes",
  "themes.messages.activateError": "Errore attivazione tema",
  "themes.messages.activateErrorFallback": "Attivazione tema fallita",
  "themes.messages.activated": "Tema attivato"
}

export default themesMessages
